import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { Button, Form, Input } from "../../../styles";
import { useUserContext } from "../../../context/user_context";
import { useExpensesContext } from "../../../context/expenses_context";
import Api from "../../../api/axios";


const AddExpCategory = (props) => {
  const [issending, setissending] = useState(false);

  const [formField, setformField] = useState({});

  const { usertoken, btoken, stoken } = useUserContext();
  const {
    openAddExpenses,
    showAddExpCategory, CloseAddExpCategory,
    getExpCategoryData
  } = useExpensesContext();

  function handleChange(e) {
    setformField((inputs) => ({
      ...inputs,
      [e.target.name]: e.target.value,
    }));
  }

  function submitFn(e) {
    e.preventDefault();
    if (formField.name) {
      setissending(true);
      const data = {
        name: formField.name,
        usertoken, btoken, stoken
      };

      Api.post(`/addExpenseCategory`, data)
        .then((res) => {
          if (res.success === false) {
            toast.warn(res.message);
            setissending(false);
          } else {
            setissending(false);
            toast.success(res.message);
            clear();
            getExpCategoryData();
            CloseAddExpCategory();
            openAddExpenses();
          }
        })
        .catch((error) => {
          setissending(false);
        });
    } else {
      setissending(false);
      toast.error("Category name is required !!!");
    }
  }

  // clear Form Field
  function clear() {
    setformField({ name: "" });
  }


  return (
    <>
      <Modal
        show={showAddExpCategory}
        onHide={CloseAddExpCategory}
        backdrop="static"
        keyboard={true}
        centered
        size="lg"
      >
        <Modal.Body>
          <Modal.Header closeButton>
            <h6 className="fw-bold pry-text ml-auto">
              Add New Expenses Category
            </h6>
          </Modal.Header>

          <section className=" ">
            <div className="container">
              <div className="text-center">
                <div className="form">
                  <Form onSubmit={(e) => submitFn(e)}>
                    <div className="row justify-content-center text-start">
                      <div className="col-md-12">
                        <label className="mb-0"> Category Name:</label>
                        <Input
                          type="text"
                          name="name"
                          placeholder="Enter category"
                          onChange={handleChange}
                          required
                          value={formField.name}
                        />
                      </div>

                      <div className="col-md-10 mx-auto text-center">

                        <div className="mb-4 text-center">
                          <Button
                            pry
                            type="submit"
                            disabled={issending}
                            className="btn m-0 w-100"  >
                            {issending ? 'loading...' : "Submit"}
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </section>
        </Modal.Body>
      </Modal>


    </>
  );
};

export default AddExpCategory;
